import { render, staticRenderFns } from "./ListRegionais.vue?vue&type=template&id=146f4d89&scoped=true"
import script from "./ListRegionais.vue?vue&type=script&lang=js"
export * from "./ListRegionais.vue?vue&type=script&lang=js"
import style0 from "./ListRegionais.vue?vue&type=style&index=0&id=146f4d89&prod&lang=scss"
import style1 from "./ListRegionais.vue?vue&type=style&index=1&id=146f4d89&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146f4d89",
  null
  
)

export default component.exports